import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import {
  Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger,
} from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Shield } from "lucide-react";

export const EthicalAgreementDialog = ({ trigger }) => {
  const [agreement, setAgreement] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open && !agreement) {
      api.get("/ethical-agreement").then(({ data }) => setAgreement(data)).catch(() => {});
    }
  }, [open, agreement]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-display text-xl">
            <Shield className="h-5 w-5 text-[hsl(174,38%,34%)]" />
            {agreement?.title || "LOOKBOOK Ethical Usage Agreement"}
          </DialogTitle>
          <DialogDescription>{agreement?.preamble}</DialogDescription>
        </DialogHeader>
        <ScrollArea className="max-h-[50vh] pr-4">
          <div className="space-y-4">
            {(agreement?.clauses || []).map((c, i) => (
              <div key={c.id} className="space-y-1">
                <h4 className="text-sm font-semibold">
                  {i + 1}. {c.title}
                </h4>
                <p className="text-sm text-muted-foreground">{c.text}</p>
              </div>
            ))}
          </div>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};
